import { Icon, LoadingButton } from '@gcl/react-core';
import './DetailPageRightMenu.scss';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { IDetailPageRightMenuTemporaryWorksFormsItem } from './detailPageRightMenuTemporaryWorksForms.models';

interface IDetailPageRightMenuTemporaryWorksFormsItemProps {
  item: IDetailPageRightMenuTemporaryWorksFormsItem;
}
export const DetailPageRightMenuTemporaryWorksFormsItem = ({
  item,
}: IDetailPageRightMenuTemporaryWorksFormsItemProps) => {
  const queryClient = useQueryClient();
  const { onClickAdd, onClickAddMutationFn, onClickAddMutationParam } = item;

  const {
    mutate: mutationAdd,
    isLoading: isLoadingMutationAdd,
    isError: isErrorMutationAdd,
    isSuccess: isSuccessMutationAdd,
    reset: resetMutationAdd,
  } = onClickAddMutationFn || {
    isLoading: false,
    isError: false,
    isSuccess: false,
    resetMutationAdd: undefined,
  };

  useEffect(() => {
    if (isSuccessMutationAdd && item.queryKeyToInvalidAfterSuccessAdd)
      queryClient.invalidateQueries(item.queryKeyToInvalidAfterSuccessAdd);
    if (resetMutationAdd) resetMutationAdd();
  }, [isSuccessMutationAdd]);

  const onClickAddMutation = () => {
    if (!onClickAddMutationFn || !mutationAdd) {
      return;
    }
    mutationAdd(onClickAddMutationParam);
  };

  return (
    <div className="gcl-gems-detail-right-menu-temp-work-item-container" key={`${item.type}-header`}>
      <div className="gcl-gems-detail-right-menu-temp-work-num" key={`${item.type}-number`}>
        {item.data?.length ?? 0}
      </div>
      <div className="gcl-gems-detail-right-menu-temp-work-title">{item.type}</div>

      {item.isAddEnable && (
        <LoadingButton
          className="gcl-mx-xs"
          onClick={onClickAddMutationFn ? onClickAddMutation : onClickAdd}
          isLoading={isLoadingMutationAdd}
          isError={isErrorMutationAdd}
          isSuccess={isSuccessMutationAdd}
          timeToResetSuccessState={3000}
          timeToResetErrorState={5000}
        >
          <Icon
            iconName="PlusLg"
            className="gcl-gems-detail-right-menu-temp-work-add-btn gcl-ic-btn-lg gcl-fc-primary-400"
          />
        </LoadingButton>
      )}
    </div>
  );
};
